export const PAYMENT_CONSTANTS = {
    STRIPE: 'stripe',
    RAZORPAY: 'razorpay',
    PUBLISHABLE_KEY: 'pk_live_51NURk6SFInqfnyW0Ns1YiVel0UnMBSKeO93Gt7lU5vKug9YZNNZYZhdB2wFXr3yCr9XDliJHKMDuFx277r1OoNf900XNtfJq4M',
    PRICING_TABLE_ID: 'prctbl_1OAsRiSFInqfnyW0DQjeD8le',
    TALENLIO_LINKEDIN: 'https://www.linkedin.com/company/talenlio/',
    TALENLIO_INSTAGRAM: 'https://www.instagram.com/talenlio/',
    RAZORPAY_RESUME_REVIEW: 'https://rzp.io/l/review-my-resume'
}
